var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi, isHDCA } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
const DEFAULT_LIMIT = 50;
/**
 * Fetches the details of a collection.
 * @param params.id The ID of the collection (HDCA) to fetch.
 */
export function fetchCollectionDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/dataset_collections/{id}", {
            params: { path: params },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
/**
 * Fetches the details of a collection.
 * @param params.id The ID of the collection (HDCA) to fetch.
 */
export function fetchCollectionSummary(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/dataset_collections/{id}", {
            params: {
                path: params,
                query: { view: "collection" },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function fetchCollectionElements(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/dataset_collections/{hdca_id}/contents/{parent_id}", {
            params: {
                path: { hdca_id: params.hdcaId, parent_id: params.collectionId },
                query: { instance_type: "history", offset: params.offset, limit: params.limit },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function fetchElementsFromCollection(params) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const hdcaId = isHDCA(params.entry) ? params.entry.id : params.entry.hdca_id;
        const collectionId = isHDCA(params.entry) ? params.entry.collection_id : params.entry.id;
        return fetchCollectionElements({
            hdcaId: hdcaId,
            collectionId: collectionId,
            offset: (_a = params.offset) !== null && _a !== void 0 ? _a : 0,
            limit: (_b = params.limit) !== null && _b !== void 0 ? _b : DEFAULT_LIMIT,
        });
    });
}
